import { render, staticRenderFns } from "./Image_ViewPublic.vue?vue&type=template&id=2bc1108c"
import script from "./Image_ViewPublic.vue?vue&type=script&lang=js"
export * from "./Image_ViewPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports